import {Card, Divider, Typography} from "antd";
import React from "react";
import TrackingForm from "./TrackingForm";
const {Title}=Typography;
const Tracking=()=>{
    return <Card>
        <div className="bg-primary mb-4 rounded-xl p-5 bg-opacity-5">
            <Title level={4}>پیشخوان ارباب رجوع</Title>
            <Divider/>
            <Title level={5}>پیگیری درخواست</Title>
            <Typography>جهت پیگیری درخواست شناسه پیگیری خود را وارد کنید.</Typography>
        </div>
        <Divider/>
        <TrackingForm/>
    </Card>
}
export default Tracking;